import { FormattedMessage } from 'react-intl';
import { useRouterActions } from 'react-resource-router';

import CustomThemeButton from '@atlaskit/button/custom-theme-button';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { StatsigFeatureKeys } from '@atlassian/bitbucket-features';

import repoUrls from 'src/sections/repository/urls';
import { publishUiEvent } from 'src/utils/analytics/publish';

import messages from './compare-button.i18n';

type Props = {
  repositoryFullSlug: string;
  source: string;
};

export const CompareButton = ({
  repositoryFullSlug,
  source,
}: Props): JSX.Element => {
  const analytics = () => {
    publishUiEvent({
      action: 'clicked',
      actionSubject: 'button',
      actionSubjectId: 'compareBranchesButton',
      source,
    });
  };

  const [owner, slug] = repositoryFullSlug.split('/');
  const { push } = useRouterActions();

  const isBranchCompareEnabled = FeatureGates.checkGate(
    StatsigFeatureKeys.frontbucketBranchCompare
  );

  return (
    <CustomThemeButton
      href={repoUrls.ui.compare(owner, slug)}
      onClick={e => {
        if (isBranchCompareEnabled) {
          e.preventDefault();
          push(repoUrls.ui.compare(owner, slug));
        }

        analytics();
      }}
    >
      <FormattedMessage {...messages.compareAction} />
    </CustomThemeButton>
  );
};
